import { createContext, useContext } from 'react';

const FormStepContext = createContext();
FormStepContext.displayName = 'FormStepContext';

const useFormStep = () => {
  const context = useContext(FormStepContext);

  if (typeof context === 'undefined') {
    throw new Error('useFormStep must be used within a FormStepContext.Provider');
  }

  return context;
};

export const { Provider: FormStepProvider } = FormStepContext;

export default useFormStep;
